import { useEffect, useState } from "react";
import OsgbBaseMapGallery from "./OsgbBaseMapGallery";
import useEsri from "../hooks/useEsri";

const MapPlaceholder = () => {
  return (
    <div className="pulse-animate flex items-center mt-2 pb-2 border-b-2 border-gray-200">
      <div className="rounded ml-1 mr-1 h-20 w-20 bg-gray-400"></div>
      <div className="rounded ml-1 mr-1 h-20 w-20 bg-gray-400"></div>
      <div className="rounded ml-1 mr-1 h-20 w-20 bg-gray-400"></div>
      <div className="rounded ml-1 mr-1 h-20 w-20 bg-gray-400"></div>
    </div>
  );
};

const MapGallery = () => {
  const { esriLoader } = useEsri();
  const [galleryCollection, setGalleryCollection] = useState();

  useEffect(() => {
    if (!esriLoader) return;
    if (esriLoader.basemapCollection) {
      setGalleryCollection(esriLoader.basemapCollection);
    }
  }, [esriLoader]);

  return (
    <>
      <p className="mb-2">Select basemap from the gallery</p>
      <div className="rounded p-1 mb-2 shadow-md border-3 bg-gray-300 border-blue-600">
        {galleryCollection ? (
          <OsgbBaseMapGallery
            basemapCollection={galleryCollection}
            LoadingPlaceholder={<MapPlaceholder />}
          />
        ) : (
          <MapPlaceholder />
        )}
      </div>
    </>
  );
};

export default MapGallery;
